import React, { Fragment } from 'react';
import { FacebookOutlined, TwitterOutlined, InstagramOutlined, LinkedinOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import "./style.css";

const Footer = () => {

  return (
    <Fragment>
      <footer class="footer">
        <div class="footer-container">
          <div class="row">
            <div class="footer-col">

              <h4>company</h4>
              <ul>
                <li><Link to="/terms-and-condition">Terms and Condition</Link></li>
                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                <li><Link to="/shipping-policy">Shiping Policy</Link></li>
                <li><Link to="/cancellation-and-refund">Cancelation and Refunds</Link></li>
              </ul>


            </div>
            {/* <div class="footer-col">
              <h4>get help</h4>
              <ul>
                <li><Link to="">FAQ</Link></li>
                <li><Link to="">shipping</Link></li>
                <li><Link to="">returns</Link></li>
                <li><Link to="">order status</Link></li>
                <li><Link to="">payment options</Link></li>
              </ul>
            </div> */}

            <div class="footer-col">
              <h4>Contact US</h4>
              <ul>
                <li><p>Contact Number: +91 80721 58693</p></li>
                <li><p>Shop Number: +91 80121 10689</p></li>
                <li><p>Email: konguvellimaligai@gmail.com</p></li>
                <li><p>191, Sedat Street, Paramathi main road,</p></li>
                <li><p>Paramathi Velur, Namakkal,</p></li>
                <li><p>Pin code 638182</p></li>
                <li><p>Tamil Nadu.</p></li>
              </ul>
            </div>
            <div class="footer-col ">
              <div class="footer-end">
                <h4 className='footer-txt'>follow us</h4>
                <div class="social-links">
                  <Link ><FacebookOutlined className='social-links-img' /></Link>
                  <Link ><TwitterOutlined className='social-links-img' /></Link>
                  <Link ><InstagramOutlined className='social-links-img' /></Link>
                  <Link ><LinkedinOutlined className='social-links-img' /></Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </Fragment >
  )
}

export default Footer;